/* istanbul ignore file */
import { UpdatePageLayout } from 'framework/ui/layout';
import { UpdateForm } from 'framework/form';
import ProjectEntityHeader from 'domain/projects/project/shared/ProjectEntityHeader';
import UpdateProjectBreadcrumbs from 'domain/projects/project/createupdate/Update/Breadcrumbs';
import ProjectForm from 'domain/projects/project/createupdate/ProjectForm';
import { useProjectService, useProjectUrl } from 'domain/shared/project';
import { useEmployeeService } from 'domain/shared/employee';

const UpdateProject = () => {
  const { update, getById, getValidationSchema, getName } = useProjectService();
  const { getSingleEntityUrl } = useProjectUrl();
  const { getById: getEmployeeById } = useEmployeeService();

  const getDataMethod = async (id: string) => {
    const { rbsTreeNode, ...data } = await getById(id);
    const realNameData = await getName(id);
    const staffingCoordinator = await getEmployeeById(data.staffingCoordinatorAlias);

    return {
      ...data,
      name: data.name,
      originalName: realNameData[id].realProjectName,
      rbsTreeNodeName: rbsTreeNode?.name,
      rbsTreeNodeId: rbsTreeNode?.id,
      redmineAlias: rbsTreeNode?.attributes.alias,
      staffingCoordinator,
    };
  };

  return (
    <UpdateForm
      submitFormFunc={update}
      getDataFunc={getDataMethod}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: getSingleEntityUrl(),
        message: 'You are awesome! The Project has been successfully saved.',
      }}
    >
      <UpdatePageLayout
        title="Edit: Project"
        breadcrumbs={<UpdateProjectBreadcrumbs />}
        entityHeader={<ProjectEntityHeader />}
      >
        <ProjectForm />
      </UpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateProject;
